import React from "react";
import Context from "../../../Context";
import DtPicker from "../../Misc/DtPicker";
import SuperSelect from "../../Misc/SuperSelect";
import EssenceAreaChange from "../EssenceAreaChange";
import EssenceReferencePositionEdit from "../EssenceReferencePositionEdit";
export default class StaffDetailProfile extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      types: {},
      data: this.props.user || {},
      emails: [""],
    };
  }
  componentDidMount() {
    if (this.props.user.id) {
      this.load();
    }
  }

  addEmail = () => {
    let emails = this.state.emails;
    emails.push("");
    this.setState({ emails });
  };

  onChangeEmails = (index, value) => {
    let emails = this.state.emails;
    emails[index] = value;
    this.setState({ emails });
  };

  load = async () => {
    let data = this.props.user;

    let emails = [];
    if (data.email && Array.isArray(data.email)) {
      emails = data.email;
    }
    if (emails.length < 1) emails.push("");

    if (!data.phone) data.phone = { mobile: "" };

    let types = await this.context.api.qo("/staff/type");
    this.setState({ types, data, emails });
  };

  save = async () => {
    const data = this.state.data;
    let emails = [];
    this.state.emails.forEach((email) => {
      if (email.trim()) emails.push(email);
    });

    let nameArray = [];
    if (data.lastname) nameArray.push(data.lastname);
    if (data.firstname) nameArray.push(data.firstname);
    if (data.middlename) nameArray.push(data.middlename);

    let fullName = nameArray.join(" ");

    let saveData = {
      id: data.id,
      type: this.context.getType(data.typecode) || null,
      email: emails || null,
      phone: data.phone || null,
      code: data.code || null,
      description: data.description || null,
      position: data.position || null,
      birthplace: data.birthplace || "",
      birthdate: data.birthdate || this.context.api.minDate,
      structure: data.structure || this.context.api.nullUuid,
      name: {
        name: fullName || "",
        first: data.firstname || "",
        last: data.lastname || "",
        middle: data.middlename || "",
      },
    };

    this.props.onPending(true);
    let result = await this.context.api.q("/staff/set", saveData);
    if (result !== false) {
      this.context.toast("Профиль сотрудника сохранен", "success");
      this.setState({ emails });
      this.props.onFinish();
    } else {
      this.context.toast("Не удалось сохранить профиль сотрудника", "error");
      this.props.onPending(false);
    }
  };
  onChange = (e) => {
    let data = this.state.data;
    const id = e.target.id;
    const value = e.target.value;

    if (id.indexOf(".") > 0) {
      let ids = id.split(".");
      data[ids[0]][ids[1]] = value;
    } else {
      data[id] = value;
    }
    this.setState({ data });
  };

  onSelectStructure = (value) => {
    this.onChange({
      target: {
        id: "structure",
        value,
      },
    });
  };

  onSelectPosition = (positionItem) => {
    let data = this.state.data;
    data.position = positionItem;
  };

  render() {
    let data = this.state.data;
    if (!data.id) return null;
    return (
      <>
        <div className="row">
          <div className="col-lg-4">
            <div className="form-group">
              <label>Фамилия:</label>
              <input
                type="text"
                className="form-control mb-3"
                value={data.lastname || ""}
                id="lastname"
                onChange={(e) => this.onChange(e)}
              />
            </div>
          </div>
          <div className="col-lg-4">
            <div className="form-group">
              <label>Имя:</label>
              <input
                type="text"
                className="form-control mb-3"
                value={data.firstname || ""}
                id="firstname"
                onChange={(e) => this.onChange(e)}
              />
            </div>
          </div>
          <div className="col-lg-4">
            <div className="form-group">
              <label>Отчество:</label>
              <input
                type="text"
                className="form-control mb-3"
                value={data.middlename || ""}
                id="middlename"
                onChange={(e) => this.onChange(e)}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-4">
            <div className="form-group">
              <label>Дата рождения:</label>
              <DtPicker
                isClearable
                onChange={(value) =>
                  this.onChange({ target: { id: "birthdate", value } })
                }
                value={data.birthdate}
              />
            </div>
          </div>
          <div className="col-lg-8">
            <div className="form-group">
              <label>Место рождения:</label>
              <input
                type="text"
                className="form-control mb-3"
                value={data.birthplace || ""}
                id="birthplace"
                onChange={(e) => this.onChange(e)}
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="form-group">
              <label>Подразделение:</label>
              <div className="input-group">
                <input
                  className="form-control   d-inline-block w-auto"
                  readOnly
                  value={data.areaname}
                />
                <div className="input-group-append">
                  <EssenceAreaChange
                    item={data}
                    onFinish={() => {
                      this.props.onFinish();
                    }}
                    button={(onClick) => (
                      <button
                        title="Сменить подразделение"
                        className="btn btn-icon border text-hover-dark-50"
                        type="button"
                        onClick={onClick}
                      >
                        <i className="fa fa-navicon"></i>
                      </button>
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="form-group">
              <label>В структуре организации:</label>
              <SuperSelect
                defaultValue={data.structure}
                onChange={(value) => this.onSelectStructure(value)}
                essence="structure"
                placeholder="Выберите из списка..."
                nameField="label"
                idField="id"
                type="soc.structure"
                reference={{
                  title: "Структура организации",
                  essence: "structure",
                  showDescription: true,
                  showType: true,
                  forceType: "soc.structure",
                  structure: true,
                }}
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="form-group">
              <label>Должность:</label>
              <SuperSelect
                defaultValue={data.position}
                onChange={(value) => this.onSelectPosition(value)}
                essence="position"
                placeholder="Выберите должность..."
                nameField="name"
                idField="id"
                reference={{
                  title: "Должности",
                  essence: "position",
                  showDescription: true,
                  showType: true,
                  itemEditor: (itemEditorProps) => (
                    <EssenceReferencePositionEdit {...itemEditorProps} />
                  ),
                }}
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="form-group">
              <label>Тип:</label>
              <select
                className="form-control"
                id="typecode"
                onChange={(e) => this.onChange(e)}
                value={data.typecode}
              >
                {Object.entries(this.state.types).map(([id, type]) => (
                  <option key={id} value={type.code}>
                    {type.description}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-6">
            <div className="form-group">
              <label>Телефон:</label>
              <input
                type="text"
                className="form-control mb-3"
                value={data.phone ? data.phone.mobile : ""}
                id="phone.mobile"
                onChange={(e) => this.onChange(e)}
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="form-group">
              <div className="d-flex justify-content-between">
                <label>E-mail:</label>
                {/*<span
                  onClick={() => this.addEmail()}
                  title="Добавить Email"
                  className="cursor-pointer  flaticon2-add-1 text-muted text-hover-primary"
                ></span>*/}
              </div>
              {this.state.emails.map((email, index) => (
                <input
                  key={index}
                  type="text"
                  className="form-control mb-3"
                  value={email || ""}
                  onChange={(e) => this.onChangeEmails(index, e.target.value)}
                />
              ))}
            </div>
          </div>
        </div>
        <div className="form-group">
          <label>Описание:</label>
          <textarea
            type="text"
            className="form-control mb-3"
            value={data.description || ""}
            id="description"
            onChange={(e) => this.onChange(e)}
          />
        </div>
        <div className="form-group">
          <button onClick={this.save} className="btn btn-primary">
            Сохранить
          </button>
        </div>
      </>
    );
  }
}
